module.exports = __webpack_public_path__ + "img/Number=2.f6f4e1a6.png";